var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.038,
    height: 37.585,
    viewBox: "0 0 30.038 37.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "profile-svgrepo-com_3_",
    "data-name": "profile-svgrepo-com (3)",
    d: "M27.484,11.515c0,6-3.627,11.157-8.457,11.157s-8.457-5.153-8.457-11.159S13.69,2,19.028,2,27.484,5.509,27.484,11.515ZM4.185,36.094c.724.861,3.839,3.492,14.843,3.492S33.145,36.955,33.87,36.1a.782.782,0,0,0,.169-.6c-.165-1.658-1.658-9.069-15.012-9.069S4.181,33.842,4.014,35.5a.782.782,0,0,0,.171.6Z",
    transform: "translate(-4.008 -2)",
    fill: "#d6c1a5",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUse);
export default __webpack_public_path__ + "static/media/profileUse.9c4cda247788689e74ee94c9371b7f81.svg";
export { ForwardRef as ReactComponent };